"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
function aWebSocketError(opts) {
    return __assign(__assign({}, opts), { transport: 'websocket' });
}
exports.aWebSocketError = aWebSocketError;
function anHttpLongPollingError(opts) {
    return __assign(__assign({}, opts), { transport: 'http_long_polling' });
}
exports.anHttpLongPollingError = anHttpLongPollingError;
//# sourceMappingURL=transport-error.js.map